import { Component, OnDestroy, OnInit } from '@angular/core';
import { OrganizationsService } from '../../../../services/organizations/organizations.service.js';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTabsModule } from '@angular/material/tabs';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { KeyValuePair } from 'allai-admin-shared';
import { OverlayModule } from '@angular/cdk/overlay';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { OrganizationsFilterService } from '../../../../services/organizations/organizations-filter.service.js';

/** The organization metric page */
@Component({
	selector: 'app-organization-patient-metrics',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTabsModule,
		MatTableModule,
		MatDatepickerModule,
		MatFormFieldModule,
		FormsModule,
		MatInputModule,
		MatTableModule,
		ReactiveFormsModule,
		OverlayModule
	],
	providers: [provideNativeDateAdapter()],
	templateUrl: './organization-patient-metrics.component.html',
	styleUrl: './organization-patient-metrics.component.scss'
})
export class OrganizationPatientMetricsComponent implements OnInit, OnDestroy {

	dateRangeControl: FormGroup;

	metricsDataSource: MatTableDataSource<KeyValuePair>;

	readonly displayedColumns: (keyof KeyValuePair)[] = ['key', 'value'];

	constructor(private organizationsService: OrganizationsService, private organizationsFilterService: OrganizationsFilterService) {

	}

	ngOnInit() {

		this.dateRangeControl = new FormGroup({
	    start: new FormControl<Date | null>(this.organizationsFilterService.metricsStartDate),
  	  end: new FormControl<Date | null>(this.organizationsFilterService.metricsEndDate)
	  });
		this.dateRangeControl.valueChanges.subscribe((value) => this.organizationsFilterService.metricsRange = value);

		this.organizationsService.onNewOrganizationDetail.subscribe(() => {
			this.refresh();
		});
	}

	private refresh() {
		let organizationDetail = this.organizationsService.organizationDetail;
		let data = organizationDetail.patientMetrics;
		this.metricsDataSource = new MatTableDataSource<KeyValuePair>(data);
	}

	ngOnDestroy() {
	}
}
